var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 78,
    viewBox: "0 0 90 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.54701 65.4093L11.812 64.2811L11.7773 76.7854L62.5812 77.0674L64.4615 74.717L63.2393 71.2384L62.1111 64.0931L64.3675 58.076L66.6239 55.9136L66.906 52.2469L73.2051 47.5461L73.2991 41.811L78.8462 36.264L78.3761 33.4435L82.1367 31.5632L80.7265 26.2982L85.1453 21.5033L84.0171 19.2469L88.0598 15.4862L89 12.0076L77.0598 11.9136L82.3248 4.39223L80.7265 1.28964H1L4.66667 24.1358L3.53847 63.2469L6.54701 65.4093Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAr);
export default __webpack_public_path__ + "static/media/AR.a167096b4b9c5f9bfc37a9130a5f2339.svg";
export { ForwardRef as ReactComponent };